import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider.js';

export function SignInPage() {
  const { signIn, error: authError } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(authError);

  async function handleSignIn() {
    setError(null);
    setLoading(true);
    try {
      await signIn();
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Sign-in failed. Try again.',
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f7f5]">
      <div className="flex flex-col items-center gap-6 w-full max-w-sm px-6">
        {/* Logo */}
        <div className="flex flex-col items-center gap-3">
          <img
            src="/atlas-icon.png"
            alt="Migration Tools"
            className="w-10 h-10 rounded-xl"
          />
          <div className="text-center">
            <h1 className="text-xl font-semibold text-[#37352f]">
              Migration Tools
            </h1>
            <p className="text-sm text-[#73726e] mt-0.5">
              Internal migration tool — Atlas team only
            </p>
          </div>
        </div>

        {/* Sign-in card */}
        <div className="w-full border border-[#e9e9e7] rounded-xl bg-white p-6 flex flex-col gap-4">
          <p className="text-sm text-[#73726e] text-center">
            Sign in with your Atlas Microsoft account to continue.
          </p>

          <button
            onClick={handleSignIn}
            disabled={loading}
            className="flex items-center justify-center gap-2.5 w-full px-4 py-2.5 text-sm font-medium text-[#37352f] border border-[#e9e9e7] rounded-lg hover:bg-[#f7f7f5] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {/* Microsoft logo */}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="0" y="0" width="7.5" height="7.5" fill="#f25022" />
              <rect x="8.5" y="0" width="7.5" height="7.5" fill="#7fba00" />
              <rect x="0" y="8.5" width="7.5" height="7.5" fill="#00a4ef" />
              <rect x="8.5" y="8.5" width="7.5" height="7.5" fill="#ffb900" />
            </svg>
            {loading ? 'Signing in…' : 'Sign in with Microsoft'}
          </button>

          {error && (
            <p className="text-xs text-[#e03e3e] text-center">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
}
